import CommentIcon from '@atlaskit/icon/core/comment';
import { Inline, xcss } from '@atlaskit/primitives';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS, tooltip } from '@databases/keyboard-shortcuts';
import { getValueId } from '@databases/utils/utils';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import { type SelectionsEffectMenuItemBuilder } from '../types';

const elementBeforeIconWrapper = xcss({
  marginRight: 'space.negative.075',
});

const elementAfterShortCutWrapper = xcss({
  backgroundColor: 'color.background.neutral',
  color: 'color.text.subtlest',
  borderRadius: 'radius.xsmall',
  padding: 'space.050',
  font: 'font.body.small',
  alignSelf: 'flex-end',
});

export const commentsMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  _actions,
  skip
) => {
  if (!context.capabilities.canOpenComments) {
    return skip;
  }

  return (_, setOpenThread) => ({
    key: SELECT_VALUE_MENU_ACTIONS.COMMENTS,
    content: context.formatMessage(messages['value-actions.comments']),
    onClick: () => {
      const valueId = getValueId(context.entryId, context.fieldId);

      setOpenThread({ valueId, create: true, panel: context.panel });

      context.closeMenu();
    },
    tooltipPosition: 'right',
    elemBefore: (
      <Inline spread="space-between" alignBlock="center" xcss={elementBeforeIconWrapper}>
        <CommentIcon label="" spacing="spacious" />
      </Inline>
    ),
    elemAfter: (
      <Inline xcss={elementAfterShortCutWrapper}>
        {tooltip(SHORTCUTS.OPEN_COMMENTS.keyMap)}
      </Inline>
    ),
  });
};
